import Component from "vue-class-component";
import Vue from "vue";
import moment from "moment";
import { helpers } from "../helpers/helper.module";
import { moneyFormat, showError } from "../helpers";
import CryptoJS from "crypto-js";
import { IOTPOptions } from "../../interfaces/IOTPOptions";

@Component
export class GlobalMixins extends Vue {
  isLoading: boolean = false;

  public getError(fieldName: any) {
    const app: any = this;
    return app.errors.first(fieldName);
  }

  public async validate() {
    const isValid: boolean = await this.$validator.validateAll();
    if (!isValid) {
      showError("Complete Required Fields");
    }
  }

  public readableDate(date: string) {
    return moment(date).format("DD MMM YYYY");
  }

  public formatDate(date: string, format: string) {
    return moment(date).format(format);
  }

  public handleError(error: any) {
    this.isLoading = false;
    helpers.HIDE_LOADING();
    if (!error.response) {
      return this.toastError(error.message);
    }
    const response = error.response.data;
    // console.log("error", response);
    this.toastError(response.message);
  }

  public toastSuccess(message: string) {
    return this.$notify({
      title: message,
      type: "success"
    });
  }

  public toastError(message: string) {
    return this.$notify({
      title: message,
      type: "error"
    });
  }

  public modal(modalId: string, show: boolean) {
    jQuery.noConflict();
    const ff: any = jQuery;
    show ? ff(`#${modalId}`).modal("show") : ff(`#${modalId}`).modal("hide");
  }

  public loadJs() {
    let main = document.createElement("script");
    main.setAttribute("src", "/assets/js/custom.js");
    main.setAttribute("id", "main-js");

    try {
      $("#main-js").remove();
      setTimeout(() => {
        document.body.appendChild(main);
      }, 1000);
    } catch (error) {
      document.body.appendChild(main);
    }
  }

  async loadDependencyJS(srcs: string[]) {
    let index = 0;
    for (const item of srcs) {
      const dependency = document.createElement("script");
      dependency.setAttribute("src", item);
      dependency.setAttribute("id", `${index}_dependency`);
      $(`${index}_dependency`).remove();
      // this.$jQuery(`${index}_dependency`).remove();
      setTimeout(() => {
        document.body.appendChild(dependency);
      }, 1100);
      index += 1;
    }
  }

  public globalLoader(status: boolean, message?: string) {
    status ? helpers.SHOW_LOADING(message) : helpers.HIDE_LOADING();
  }

  public showLoading(message?: string) {
    helpers.SHOW_LOADING(message);
  }

  public hideLoading() {
    helpers.HIDE_LOADING();
  }

  public requestWrapper<T>(promise: Promise<T>): Promise<T> {
    this.showLoading();
    return new Promise((resolve, reject) => {
      promise
        .then((response: any) => {
          this.hideLoading();
          resolve(response);
        })
        .catch((error: any) => {
          this.hideLoading();
          this.handleError(error);
          throw new Error("requestWrapper error");
        });
    });
  }

  moneyFormat(value: number) {
    return moneyFormat(value);
  }

  confirm(payload: any, func: any, success?: string) {
    return new Promise((resolve, reject) => {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(async (result: any) => {
        if (result.value) {
          try {
            await func(payload);
            if (success)
              this.$swal({
                title: "Success!",
                text: success,
                type: "success"
              });
            resolve(true);
          } catch (error) {
            reject(error);
          }
        } else {
          resolve(false);
        }
      });
    });
  }

  makeOTPScreenPayload(payload: IOTPOptions) {
    return CryptoJS.AES.encrypt(JSON.stringify(payload), "otpPayload").toString();
  }

  getOTPScreenPayload(hash: string): IOTPOptions {
    const bytes = CryptoJS.AES.decrypt(hash, "otpPayload");
    const payload = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return payload;
  }
}
